// extracted by mini-css-extract-plugin
export var attachButton = "_ck-8";
export var sendButton = "_ck-2";
export var sendDisabled = "_ck-4";
export var sendEnabled = "_ck-3";
export var sendIcon = "_ck-6";
export var sendIconDisabled = "_ck-7";
export var sendStreaming = "_ck-5";
export var textarea = "_ck-1";
export var wrapper = "_ck-0";